import script from "./ComputeTaskStatusBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComputeTaskStatusBadge.vue?vue&type=script&lang=ts&setup=true"

import "./ComputeTaskStatusBadge.vue?vue&type=style&index=0&id=7b9c31a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b9c31a8"]])

export default __exports__